import { render, staticRenderFns } from "./Limiteds.vue?vue&type=template&id=208c9228&scoped=true"
import script from "./Limiteds.vue?vue&type=script&lang=js"
export * from "./Limiteds.vue?vue&type=script&lang=js"
import style0 from "./Limiteds.vue?vue&type=style&index=0&id=208c9228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c9228",
  null
  
)

export default component.exports